export const getFromLocalStorage = (key) => {
    const value = localStorage.getItem(key);
    return value;
}

export const saveToLocalStorage = (key, value) => {
    localStorage.setItem(key, value);
}